export const LAYOUT_CONFIG = {
  HEADER_HEIGHT: 80,
  SEARCHBAR_HEIGHT: 120,
  SEARCHBAR_HEIGHT_COMPACT: 80,
  SAFE_AREA: {
    TOP: '0px'
  },
  Z_INDEX: {
    HEADER: 50,
    FLOATING_SEARCHBAR: 40,
    MODAL: 100, 
    DROPDOWN: 30,
    TOOLTIP: 20,
    SEARCHBAR: 40
  }
};